/**
 * @generated SignedSource<<564f2efc406a02bce7f5ecbb9603ca8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentLiveTagContent$data = {
  readonly flattenTypeIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly tmpLiveArticle?: {
    readonly status: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "contentLiveTagContent";
};
export type contentLiveTagContent$key = {
  readonly " $data"?: contentLiveTagContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentLiveTagContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentLiveTagContent",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "flattenTypeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LiveArticle",
          "kind": "LinkedField",
          "name": "tmpLiveArticle",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "e6d91a72a48ae6d2f8f2ee12b8b09219";

export default node;
